import { Injectable } from '@angular/core';
import { DefaultTranspiler, TranspileParams } from '@jsverse/transloco';

const PLURAL = /\{\s*(\w+)\s*,\s*plural\s*,\s*one\s*\{([^{}]*)\}\s*other\s*\{([^{}]*)\}\s*\}/g;

/**
 * Разгъва `{count, plural, one {# собственик} other {# собственика}}` по числото
 * в параметрите (`#` става числото). Български и английски имат същите две форми:
 * `one` само за 1, всичко останало — `other`.
 */
export function resolvePlurals(value: string, params: Record<string, unknown> = {}): string {
  return value.replace(PLURAL, (match, name: string, one: string, other: string) => {
    const n = params[name];
    if (typeof n !== 'number') return match;
    return (n === 1 ? one : other).replace(/#/g, String(n));
  });
}

@Injectable()
export class PluralTranspiler extends DefaultTranspiler {
  override transpile(args: TranspileParams): unknown {
    const { value, params } = args;
    if (typeof value === 'string' && value.includes('plural,')) {
      return super.transpile({ ...args, value: resolvePlurals(value, params) });
    }
    return super.transpile(args);
  }
}
